import React, { useEffect, useState } from 'react';
import axios from 'axios.js';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { Button } from 'app/components';
import { Pagination } from "app/components/enotifica/pagination";

interface UserLogProps {
  userId?: string;
}

function UserLog({ userId }: UserLogProps) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [size, setSize] = useState(6);
  const [length, setLength] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPages, setMaxPages] = useState(1);

  const handleChangePage  = (event, value) => {
    setPage(value);
  };

  const handleChangeSize = (e) => {
    setSize(e.target.value);
  }

  useEffect(()=> {
    fetchData();
  }, [size, page]);

  useEffect(() => {
    fetchData();
  }, [userId]);

  const fetchData = () => {
    axios.get(`/users/admin/${userId}/access`, {params: { size, page }})
    .then((response) => {
      setLogs(response.data.access);
      setLength(response.data?.count);
      setMaxPages(Math.ceil(response.data?.count/ Number(size)));
      setLoading(false);
    })
    .catch((error) => {
      console.error('Erro ao carregar os logs:', error);
      setLoading(false);
    });
  }

  return (
    <div className="tw-w-full tw-px-6 tw-pb-6">

      <TableContainer component={Paper} className="tw-p-6 tw-bg-white tw-shadow-md tw-rounded-lg">
        <h2 className="tw-text-xl tw-font-bold tw-mb-4">LOG de acesso do usuário</h2>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Data e hora do acesso</TableCell>
              <TableCell>IP do usuário</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={2} align='center'>
                  Carregando logs...
                </TableCell>
              </TableRow>
            ) : logs.length > 0 ? (
              logs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell>{moment(log.accessAt).format('DD/MM/YYYY HH:mm')}</TableCell>
                  <TableCell>{log.ip}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2} className="tw-text-center">
                  Nenhum log encontrado.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Pagination.Root className="flex flex-row mt-6 justify-end">
          <Pagination.PeerPage className="mr-5" value={size} handleChange={handleChangeSize}></Pagination.PeerPage>
          <Pagination.Element count={maxPages} page={page} onChange={handleChangePage} ></Pagination.Element>
        </Pagination.Root>
        <Button.Root className="tw-flex tw-justify-end tw-mt-4">
          <Button.Element
            variant="secondary"
            className="tw-w-[180px] tw-min-w-[180px] tw-max-w-[200px]"
            onClick={() => window.history.back()}
          >
            <Button.Text text='Voltar' variant='secondary' />
            
          </Button.Element>
        </Button.Root>
      </TableContainer>
    </div>
  );
}

export default UserLog;
